let playingSound = false

const chooseAudioFiles = () => {
  if (window.appConfig.CUSTOMER === 'spar-sa') {
    return {
      notification: '/sounds/spar-sa-notification-v2.mp3',
      error: '/sounds/spar-sa-notification-error-v2.mp3',
    }
  }

  return {
    notification: '/sounds/default-notification.mp3',
    error: '/sounds/default-notification-error.mp3',
  }
}

type NotificationType = 'notification' | 'error'

export const playNotificationSound = (type: NotificationType) => {
  const audioFiles = chooseAudioFiles()

  try {
    const soundFile = audioFiles[type]
    const audio = new Audio(soundFile)
    audio.volume = 0.5

    if (playingSound) {
      return
    }

    playingSound = true

    audio.play().finally(() => {
      playingSound = false
    })
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('Error playing notification sound:', error)
  }
}
